import React from 'react';
import { Link } from 'react-scroll';

import { useIntl } from 'ha/i18n';
import { makeStyles } from 'tss-react/mui';

import { Grid, Typography, units } from '@hbf/dsl';
import { QuestionCircleLight } from '@ha/icons';

const useStyles = makeStyles()(theme => ({
  faqSection: {
    margin: units.yx(0, 0.899),
    marginBottom: units.rem(0.5),
    marginTop: units.rem(1),
  },
  icon: {
    fontSize: units.rem(1.125),
    color: theme.palette.primary.dark,
    marginRight: units.rem(0.5),
  },
  link: {
    cursor: 'pointer',
  },
  title: {
    color: theme.palette.primary.dark,
    marginBottom: units.rem(0.406),
  },
}));

interface Props {
  linkTo: string;
}

const UserCardStats: React.FC<Props> = ({ linkTo }) => {
  const { T } = useIntl();
  const { classes } = useStyles();

  return (
    <Grid container data-test-locator="Redesign/UserCard/UserCardStats">
      <Grid item xs>
        <div className={classes.faqSection}>
          <Link
            to={linkTo}
            offset={-76}
            smooth="true"
            duration={500}
            className={classes.link}
          >
            <Grid container direction="row" alignItems="center">
              <Grid item>
                <QuestionCircleLight className={classes.icon} />
              </Grid>
              <Grid item>
                <Typography.Paragraph className={classes.title}>
                  {T('ldp.faq.anchor')}
                </Typography.Paragraph>
              </Grid>
            </Grid>
          </Link>
        </div>
      </Grid>
    </Grid>
  );
};

export { UserCardStats };
